import { Pipe, PipeTransform } from '@angular/core';
import { TranslationsService } from '../services/translations.service';

@Pipe({ name: 'translateOrFallback' })
export class TranslateOrFallbackPipe implements PipeTransform {
  public constructor(private translations: TranslationsService) {}

  public transform(value: any, ...args: any[]) {
    return this.translations.translate(value, args[0] ?? '');
  }
}
